import { IDFShippingMode } from "@redotech/redo-integrations-definitions-common/integration/idf-shipping/idf-shipping-types";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const idfShippingSettings = defineIntegrationSettings({
  fields: {
    clientId: z.string().trim().min(1, "Client ID is required"),
    tenantId: z.string().trim().min(1, "Tenant ID is required"),
    mode: z.nativeEnum(IDFShippingMode),
    carrierBlacklist: z.array(z.string().trim()),
  },
  secrets: {
    clientSecret: z.string().trim().min(1, "Client secret is required"),
  },
  connectOnly: {},
  computed: {},
});
